import React, { useCallback, useState, FormEvent } from 'react';
import { navigate } from 'gatsby';
import * as Yup from 'yup';
import { FiAlertCircle } from 'react-icons/fi';
import { getErrorMessage } from '../../../utils/validations/errors';
import Input from '../../Input/Input';
import Button from '../../Button';
import { useRegister } from '../../../hooks/register';
import { isValidPassword } from '../../../utils/validations/password';
import PasswordRules from '../../PasswordRules';
import { ErrorMessage, SignHeadText } from '../../../styles/globalStyled';
import { registerUser } from '../../../services/register';
import { useModal } from '../../../hooks/modal';
import { SignupModalContainer, BackButton } from '../styles';

const PasswordSignUp: React.FC = () => {
  const { loading, handleData, userData, handleStep, handleLoading } = useRegister();
  const [password, setPassword] = useState(userData?.password || '');
  const [repassword, setRepassword] = useState('');
  const [error, setError] = useState('');
  const { handleModal } = useModal();

  const validation = Yup.object().shape({
    password: Yup.string()
      .required('O campo senha é obrigatório')
      .test('invalidPassword', 'A senha não atende às regras', (value) => isValidPassword(value || '')),
    repassword: Yup.string().oneOf([Yup.ref('password')], 'As senham não coincidem'),
  });

  const handlePasswordChange = useCallback(
    async (value) => {
      setPassword(value);
      setError('');
      handleData({ password: value });
    },
    [password],
  );

  const handleRepasswordChange = useCallback(
    async (value) => {
      setRepassword(value);
      setError('');
    },
    [repassword],
  );

  const onSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      handleLoading(true);

      if (validation.isValidSync({ password, repassword })) {
        try {
          await registerUser(userData);
          handleStep('registered');
        } catch (e) {
          if (e.response.status === 422) {
            handleStep('alreadyRegistered');
          } else {
            handleStep('registerError');
          }

          handleModal({ isOpen: false, action: '' });
          navigate('/register');
        }
      } else {
        const errorMessage = await getErrorMessage(validation, { password, repassword });
        setError(errorMessage);
      }

      handleLoading(false);
    },
    [userData, password, repassword],
  );

  return (
    <SignupModalContainer>
      <SignHeadText>
        <label>Criar senha em Allya</label>
        <p>Sua senha não deve ser a mesma que você utiliza no acesso corporativo:</p>
      </SignHeadText>
      <form onSubmit={onSubmit}>
        <Input
          autoFocus
          autoComplete="off"
          name="password"
          type="password"
          placeholder="Senha"
          width="full"
          value={password}
          onChangeValue={handlePasswordChange}
          disabled={loading}
        />

        <PasswordRules value={password} />

        <Input
          autoComplete="off"
          name="repassword"
          type="password"
          placeholder="Repetir senha"
          width="full"
          value={repassword}
          onChangeValue={handleRepasswordChange}
          disabled={loading}
        />

        <ErrorMessage visibility={error ? 1 : 0}>
          <FiAlertCircle size={20} />
          {error}
        </ErrorMessage>

        <Button
          style={{ marginTop: 50 }}
          loading={loading}
          disabled={loading}
          title="Continuar"
          classType={`big fat orange center ${!validation.isValidSync({ password, repassword }) ? 'disabled' : ''}`}
          type="submit"
        />

        {/* ${rulesChecked !== passwordValidItems.length ? 'disabled' : ''} */}

        <BackButton onClick={() => handleStep('fillEmail')} />
      </form>
    </SignupModalContainer>
  );
};

export default PasswordSignUp;
